import { render } from "./legoToastExtend.vue?vue&type=template&id=52d5e799&scoped=true"
import script from "./legoToastExtend.vue?vue&type=script&lang=js"
export * from "./legoToastExtend.vue?vue&type=script&lang=js"

import "./legoToastExtend.vue?vue&type=style&index=0&id=52d5e799&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d5e799"],['__file',"src/components/lego/extend/legoToastExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52d5e799"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52d5e799', __exports__)) {
    api.reload('52d5e799', __exports__)
  }
  
  module.hot.accept("./legoToastExtend.vue?vue&type=template&id=52d5e799&scoped=true", () => {
    api.rerender('52d5e799', render)
  })

}


export default __exports__